module.exports = __webpack_public_path__ + "static/chro-kelly-culler.b0a91acb.webp";